import { render, staticRenderFns } from "./ViewPatientHistory.vue?vue&type=template&id=c11c0580&"
import script from "./ViewPatientHistory.vue?vue&type=script&lang=js&"
export * from "./ViewPatientHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports